/**
 * @module Utilities/Strings
 * @desc Strings helper funtions
 */

/**
 * Remove format from a given number
 */
export function clearNumber(value = '') {
  return value.replace(/\D+/g, '');
}
